
const commission = () => import('@/views/main/commission/commission.vue')
export default {
  path: '/main/commission',
  name: 'commission',
  component: commission,
  children: []
}
